import { AttributeBadge } from '@/components/games/attribute-badge';
import UnnormalIcon from '@icons/game-difficulties/unnormal.svg?react';
import EasyIcon from '@icons/game-difficulties/easy.svg?react';
import NormalIcon from '@icons/game-difficulties/normal.svg?react';
import HardIcon from '@icons/game-difficulties/hard.svg?react';

const difficultyMap: Record<
  string,
  { label: string; Icon: React.FC<React.SVGProps<SVGSVGElement>> }
> = {
  '1': { label: 'Очень легко', Icon: EasyIcon },
  '2': { label: 'Легко', Icon: EasyIcon },
  '3': { label: 'Нормально', Icon: NormalIcon },
  '4': { label: 'Сложно', Icon: HardIcon },
  '5': { label: 'Очень сложно', Icon: UnnormalIcon },
};

interface DifficultyBadgeProps {
  level: string | number;
  className?: string;
}

export function DifficultyBadge({ level, className }: DifficultyBadgeProps) {
  const { label, Icon } = difficultyMap[String(level)] ?? difficultyMap['2'];

  return (
    <AttributeBadge
      className={className}
      label={label}
      icon={<Icon className="w-5 h-5 @lg/gameCard:w-7 @lg/gameCard:h-7 opacity-50" />}
    />
  );
}
